// extracted by mini-css-extract-plugin
module.exports = {"navigation":"mobile-navigation-module--navigation--J5s_e","logo":"mobile-navigation-module--logo--1NJKv","link":"mobile-navigation-module--link--VKgYH"};